/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Check_RetryInputs */

const en_auth_x15_check_retry = /** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the check again`)
};

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const ar_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const he_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const ur_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const es_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const fr_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const de_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const pt_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const hi_auth_x15_check_retry = en_auth_x15_check_retry;

/** @type {(inputs: Auth_X15_Check_RetryInputs) => LocalizedString} */
const bn_auth_x15_check_retry = en_auth_x15_check_retry;

/**
* | output |
* | --- |
* | "Try the check again" |
*
* @param {Auth_X15_Check_RetryInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_x15_check_retry = /** @type {((inputs?: Auth_X15_Check_RetryInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Check_RetryInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_x15_check_retry(inputs)
	if (locale === "he") return he_auth_x15_check_retry(inputs)
	if (locale === "ur") return ur_auth_x15_check_retry(inputs)
	if (locale === "es") return es_auth_x15_check_retry(inputs)
	if (locale === "fr") return fr_auth_x15_check_retry(inputs)
	if (locale === "de") return de_auth_x15_check_retry(inputs)
	if (locale === "pt") return pt_auth_x15_check_retry(inputs)
	if (locale === "hi") return hi_auth_x15_check_retry(inputs)
	if (locale === "bn") return bn_auth_x15_check_retry(inputs)
	return /** @type {LocalizedString} */ ("Try the check again")
});